// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMCalendar.tsx — PropelMapper calendar module.
//
// A month grid + a selected-day agenda panel, standardized from the web-app home
// calendar. Events are categorized (visit / follow-up / task by default) — the
// category color drives the legend, the day dots, and the agenda event's left
// category stripe (the same category-stripe pattern PMKanban uses). Token-driven,
// light/dark. Uncontrolled with callbacks (defaultMonth / defaultSelectedDate).
//
// Dates are plain "YYYY-MM-DD" strings (no timezone math).
//
//   <PMCalendar
//     events={[{ id:1, date:"2026-06-19", type:"visit", title:"South Plots — soil sampling",
//                subtitle:"Soil program · 7.1 mi", time:"9:15 AM" }]}
//     defaultSelectedDate="2026-06-19"
//     headerLink={{ label:"Open full calendar", onClick }} />

const PMCAL_CSS = `
.pmcal{box-sizing:border-box;font-family:var(--pm-font-sans);color:var(--pm-fg-1)}
.pmcal.is-card{background:var(--pm-surface);border:1px solid var(--pm-border-card);border-radius:var(--pm-radius-xl,18px);box-shadow:var(--pm-shadow-card);padding:18px 20px 20px}
.pmcal *{box-sizing:border-box}
.pmcal-head{display:flex;align-items:center;gap:8px;margin:0 0 16px;font:var(--pm-section);font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:var(--pm-fg-1)}
.pmcal-head .pmcal-ico{display:inline-flex;width:18px;height:18px;color:var(--pm-primary);flex:0 0 18px}
.pmcal-head .pmcal-ico svg{display:block;width:100%;height:100%}
.pmcal-link{margin-left:auto;display:inline-flex;align-items:center;gap:3px;font:600 13px/1 var(--pm-font-sans);color:var(--pm-primary);text-transform:none;letter-spacing:0;cursor:pointer;background:none;border:none;font-family:inherit}
.pmcal-link:hover{color:var(--pm-primary-dark)}
.pmcal-link .pmcal-ico{width:15px;height:15px;color:currentColor}

.pmcal-body{display:grid;grid-template-columns:minmax(0,1fr) 300px;gap:24px;align-items:start}
.pmcal--noagenda .pmcal-body{grid-template-columns:minmax(0,1fr)}
@media (max-width:720px){.pmcal-body{grid-template-columns:minmax(0,1fr)}}

.pmcal-nav{display:flex;align-items:center;gap:10px;margin-bottom:12px}
.pmcal-month{font:var(--pm-headline-s);font-weight:700;margin:0}
.pmcal-navbtn{width:32px;height:32px;border-radius:var(--pm-radius-m,8px);border:1px solid var(--pm-border);background:var(--pm-surface);display:grid;place-items:center;cursor:pointer;color:var(--pm-fg-2);padding:0}
.pmcal-navbtn:hover{color:var(--pm-fg-1);border-color:var(--pm-border-dark)}
.pmcal-navbtn:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmcal-navbtn .pmcal-ico{width:18px;height:18px}
.pmcal-navbtn .pmcal-ico svg{display:block;width:100%;height:100%}
.pmcal-today{margin-left:auto;font:600 13px/1 var(--pm-font-sans);border:1px solid var(--pm-border);background:var(--pm-surface);color:var(--pm-fg-1);border-radius:var(--pm-radius-pill,999px);padding:7px 15px;cursor:pointer;min-height:34px;font-family:inherit}
.pmcal-today:hover{border-color:var(--pm-border-dark)}
.pmcal-today:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}

.pmcal-legend{display:flex;gap:16px;flex-wrap:wrap;margin-bottom:12px}
.pmcal-leg{display:inline-flex;align-items:center;gap:6px;font:var(--pm-label-m);font-weight:600;color:var(--pm-fg-2)}
.pmcal-leg i{width:8px;height:8px;border-radius:50%;flex:0 0 8px}

.pmcal-dow{display:grid;grid-template-columns:repeat(7,1fr);gap:6px;margin-bottom:6px}
.pmcal-dow span{text-align:center;font:var(--pm-label-s);font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:var(--pm-fg-3)}
.pmcal-weeks{display:grid;grid-template-columns:repeat(7,1fr);gap:6px}
.pmcal-cell{position:relative;min-height:62px;border:1px solid var(--pm-border-light);border-radius:var(--pm-radius-l,12px);background:var(--pm-surface);padding:8px 8px 6px;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit;text-align:center}
.pmcal-cell:hover{border-color:var(--pm-primary-light)}
.pmcal-cell:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmcal-cell .dn{font:var(--pm-title-m);font-weight:600;color:var(--pm-fg-1)}
.pmcal-cell.is-out{background:var(--pm-surface-variant);cursor:default}
.pmcal-cell.is-out .dn{color:var(--pm-fg-3);font-weight:500}
.pmcal-cell.is-today{background:var(--pm-primary-surface);border-color:var(--pm-primary-light)}
.pmcal-cell.is-selected{border-color:var(--pm-primary);box-shadow:inset 0 0 0 1px var(--pm-primary)}
.pmcal-dots{display:flex;align-items:center;gap:4px;min-height:8px}
.pmcal-dots i{width:6px;height:6px;border-radius:50%;flex:0 0 6px}
.pmcal-dots .more{font:var(--pm-label-s);font-weight:700;color:var(--pm-fg-3);margin-left:1px;line-height:1}

.pmcal-agenda{min-width:0}
.pmcal-ag-h{font:var(--pm-title-l);font-weight:700;margin:0 0 1px}
.pmcal-ag-sub{font:var(--pm-body-s);color:var(--pm-fg-3);margin:0 0 12px}
.pmcal-event{position:relative;background:var(--pm-surface);border:1px solid var(--pm-border-light);border-radius:var(--pm-radius-l,12px);padding:11px 13px 11px 16px;margin-bottom:8px;cursor:pointer;overflow:hidden}
.pmcal-event:hover{border-color:var(--pm-border-dark)}
.pmcal-event:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmcal-event::before{content:"";position:absolute;left:0;top:0;bottom:0;width:4px;background:var(--pmcal-stripe,var(--pm-primary))}
.pmcal-event-top{display:flex;align-items:flex-start;gap:8px}
.pmcal-event-t{font:var(--pm-title-m);font-weight:600;flex:1;min-width:0}
.pmcal-event-badge{font:var(--pm-label-s);font-weight:700;text-transform:uppercase;letter-spacing:.04em;border-radius:var(--pm-radius-s,6px);padding:2px 7px;flex:0 0 auto;color:var(--pmcal-stripe,var(--pm-primary));background:var(--pm-surface-variant)}
.pmcal-event-m{font:var(--pm-body-s);color:var(--pm-fg-2);margin-top:3px}
.pmcal-event-time{font:var(--pm-label-m);font-weight:600;color:var(--pm-fg-3);margin-top:3px}
.pmcal-ag-empty{font:var(--pm-body-s);color:var(--pm-fg-3);padding:18px 0}
`;

function pmcalEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmcal-css")) return;
  const s = document.createElement("style"); s.id = "pmcal-css"; s.textContent = PMCAL_CSS;
  document.head.appendChild(s);
}

const PMCAL_DEFAULT_CATS: any = {
  visit: { label: "Visit", color: "var(--pm-primary)" },
  "follow-up": { label: "Follow-up", color: "var(--pm-secondary)" },
  task: { label: "Task", color: "var(--pm-info)" },
};
const PMCAL_MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const PMCAL_DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const PMCAL_DOW_FULL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const pmcalPad = (n: number) => (n < 10 ? "0" + n : "" + n);
const pmcalKey = (y: number, m0: number, d: number) => y + "-" + pmcalPad(m0 + 1) + "-" + pmcalPad(d);
function pmcalParse(s: any) { if (!s) return null; const p = String(s).split("-"); return { y: +p[0], m: +p[1] - 1, d: +p[2] }; }
function pmcalTodayKey() { const t = new Date(); return pmcalKey(t.getFullYear(), t.getMonth(), t.getDate()); }

function PMCalIcon({ name, fallback = "" }: any) {
  const I = (typeof window !== "undefined" && (window as any).PM_ICONS) || {};
  const svg = name ? (I[name] || I[name + "-outline"] || I[name + "-filled"]) : null;
  if (svg) return <span className="pmcal-ico" aria-hidden="true" style={{ ["--icon-fg" as any]: "currentColor" }} dangerouslySetInnerHTML={{ __html: svg }} />;
  if (fallback) return <span className="pmcal-ico" aria-hidden="true" style={{ fontWeight: 700 }}>{fallback}</span>;
  return null;
}

export function PMCalendar({
  events = [],
  categories = PMCAL_DEFAULT_CATS,
  defaultMonth,
  defaultSelectedDate,
  onSelectDate,
  onMonthChange,
  onEventClick,
  headerLink = null,
  title = "Calendar",
  icon = "calendar",
  showAgenda = true,
  showLegend = true,
  showHeader = true,
  bare = false,
  weekStartsOn = 0,
  maxDots = 3,
  className = "",
  style = {},
}: any) {
  pmcalEnsureCSS();
  const R = React as any;

  const initMonth = () => {
    const base = defaultMonth ? (pmcalParse(defaultMonth) || null) : null;
    const sel = defaultSelectedDate ? pmcalParse(defaultSelectedDate) : null;
    if (base) return { y: base.y, m: base.m };
    if (sel) return { y: sel.y, m: sel.m };
    const t = new Date(); return { y: t.getFullYear(), m: t.getMonth() };
  };
  const [view, setView] = R.useState(initMonth);
  const [selected, setSelected] = R.useState(defaultSelectedDate || pmcalTodayKey());

  // events grouped by date key
  const byDate = R.useMemo(() => {
    const map: any = {};
    (events || []).forEach((e: any) => { (map[e.date] = map[e.date] || []).push(e); });
    return map;
  }, [events]);

  const cat = (type: string) => categories[type] || { label: type, color: "var(--pm-fg-3)" };
  const todayKey = pmcalTodayKey();

  const setMonth = (y: number, m: number) => {
    let nm = m, ny = y;
    if (nm < 0) { nm = 11; ny--; } if (nm > 11) { nm = 0; ny++; }
    setView({ y: ny, m: nm });
    if (onMonthChange) onMonthChange(pmcalKey(ny, nm, 1).slice(0, 7));
  };
  const selectDay = (key: string) => { setSelected(key); if (onSelectDate) onSelectDate(key); };

  // build the weeks matrix
  const first = new Date(view.y, view.m, 1);
  let lead = first.getDay() - weekStartsOn; if (lead < 0) lead += 7;
  const daysInMonth = new Date(view.y, view.m + 1, 0).getDate();
  const cells: any[] = [];
  for (let i = 0; i < lead; i++) {
    const d = new Date(view.y, view.m, -(lead - 1 - i));
    cells.push({ y: d.getFullYear(), m: d.getMonth(), d: d.getDate(), out: true });
  }
  for (let d = 1; d <= daysInMonth; d++) cells.push({ y: view.y, m: view.m, d, out: false });
  while (cells.length % 7 !== 0) {
    const last = cells[cells.length - 1];
    const nd = new Date(last.y, last.m, last.d + 1);
    cells.push({ y: nd.getFullYear(), m: nd.getMonth(), d: nd.getDate(), out: true });
  }

  const dow = PMCAL_DOW.slice(weekStartsOn).concat(PMCAL_DOW.slice(0, weekStartsOn));

  const selParsed = pmcalParse(selected);
  const selEvents = (byDate[selected] || []);
  const selDate = selParsed ? new Date(selParsed.y, selParsed.m, selParsed.d) : null;

  const legendCats = Object.keys(categories);

  return (
    <div className={"pmcal" + (bare ? "" : " is-card") + (showAgenda ? "" : " pmcal--noagenda") + (className ? " " + className : "")} style={style}>
      {showHeader ? (
        <div className="pmcal-head">
          {icon ? <PMCalIcon name={icon} /> : null}
          <span>{title}</span>
          {headerLink ? <button type="button" className="pmcal-link" onClick={headerLink.onClick}>{headerLink.label}<PMCalIcon name="chevron-right" fallback="›" /></button> : null}
        </div>
      ) : null}

      <div className="pmcal-body">
        <div className="pmcal-cal">
          <div className="pmcal-nav">
            <h3 className="pmcal-month">{PMCAL_MONTHS[view.m]} {view.y}</h3>
            <button type="button" className="pmcal-navbtn" aria-label="Previous month" onClick={() => setMonth(view.y, view.m - 1)}><PMCalIcon name="chevron-left" fallback="‹" /></button>
            <button type="button" className="pmcal-navbtn" aria-label="Next month" onClick={() => setMonth(view.y, view.m + 1)}><PMCalIcon name="chevron-right" fallback="›" /></button>
            <button type="button" className="pmcal-today" onClick={() => { const t = new Date(); setView({ y: t.getFullYear(), m: t.getMonth() }); selectDay(todayKey); }}>Today</button>
          </div>

          {showLegend ? (
            <div className="pmcal-legend">
              {legendCats.map((k) => <span className="pmcal-leg" key={k}><i style={{ background: cat(k).color }} />{cat(k).label}</span>)}
            </div>
          ) : null}

          <div className="pmcal-dow">{dow.map((d) => <span key={d}>{d}</span>)}</div>
          <div className="pmcal-weeks">
            {cells.map((c) => {
              const key = pmcalKey(c.y, c.m, c.d);
              const evs = byDate[key] || [];
              const isToday = key === todayKey;
              const isSel = key === selected;
              const dots = evs.slice(0, maxDots);
              const extra = evs.length - dots.length;
              return (
                <button
                  type="button"
                  key={key + (c.out ? "-o" : "")}
                  className={"pmcal-cell" + (c.out ? " is-out" : "") + (isToday ? " is-today" : "") + (isSel ? " is-selected" : "")}
                  aria-label={PMCAL_MONTHS[c.m] + " " + c.d + (evs.length ? ", " + evs.length + " events" : "")}
                  aria-current={isToday ? "date" : undefined}
                  aria-pressed={isSel}
                  onClick={() => !c.out && selectDay(key)}
                >
                  <span className="dn">{c.d}</span>
                  <span className="pmcal-dots">
                    {dots.map((e: any, i: number) => <i key={i} style={{ background: cat(e.type).color }} />)}
                    {extra > 0 ? <span className="more">+{extra}</span> : null}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        {showAgenda ? (
          <div className="pmcal-agenda">
            <h4 className="pmcal-ag-h">{selDate ? PMCAL_DOW_FULL[selDate.getDay()] : ""}</h4>
            <p className="pmcal-ag-sub">{selDate ? PMCAL_DOW_FULL[selDate.getDay()] + ", " + PMCAL_MONTHS[selParsed.m] + " " + selParsed.d : ""}</p>
            {selEvents.length === 0 ? <div className="pmcal-ag-empty">Nothing scheduled.</div> : null}
            {selEvents.map((e: any, i: number) => (
              <div
                key={e.id != null ? e.id : i}
                className="pmcal-event"
                style={{ ["--pmcal-stripe" as any]: cat(e.type).color }}
                onClick={() => onEventClick && onEventClick(e)}
                tabIndex={0}
              >
                <div className="pmcal-event-top">
                  <span className="pmcal-event-t">{e.title}</span>
                  <span className="pmcal-event-badge">{e.badge || cat(e.type).label}</span>
                </div>
                {e.subtitle ? <div className="pmcal-event-m">{e.subtitle}</div> : null}
                {e.time ? <div className="pmcal-event-time">{e.time}</div> : null}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
